import { useEffect } from 'react';
import LoadingSpinner from './LoadingSpinner';
import { goToLearning } from '../../utils/learningUrl';

/** Leaves the SPA and opens the external learning app. */
const LearningHardRedirect = () => {
  useEffect(() => {
    goToLearning();
  }, []);

  return <LoadingSpinner size="md" label="Opening Learning…" fullPage />;
};

export default LearningHardRedirect;
